import { isNil } from 'lodash'
import { Mutation } from 'vuex'
import { baseExtraAnswers, getInitialState, NewAttendanceFormState } from './state'

export default {
  /** @type {Mutation<NewAttendanceFormState>} */
  setQuestions(state, questions) {
    state.questions = questions
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setParameters(state, parameters) {
    state.parameters = parameters
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  updateParameter(state, { parameter, value }) {
    state.parameters[parameter] = value
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  updateAnswer(state, { questionKey, value }) {
    if (isNil(value)) {
      delete state.answers[questionKey]
      return
    }

    state.answers[questionKey] = value
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  addSideEffect(state, { questionKey, callback }) {
    if (!state.sideEffects[questionKey]) {
      state.sideEffects[questionKey] = { callbacks: [callback], shouldRun: false }
      return
    }

    state.sideEffects[questionKey].callbacks.push(callback)
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  updateSideEffectStatus(state, { questionKey, shouldRun }) {
    if (!state.sideEffects[questionKey]) {
      return
    }
    state.sideEffects[questionKey].shouldRun = shouldRun
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  updateExtraAnswer(state, { name, value }) {
    state.extraAnswers[name] = value
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  updatePatientData(state, partialPatientData) {
    state.patientData = {
      ...state.patientData,
      ...partialPatientData,
    }
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  toggleSimplified(state) {
    state.simplified = !state.simplified
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setFormLayout(state, formLayout) {
    state.formLayout = formLayout
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setPatientData(state, patientData) {
    state.patientData = patientData
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setDisease(state, disease) {
    state.disease = disease
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setAnswers(state, answers) {
    state.answers = answers
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setExtraAnswers(state, extraAnswers) {
    state.extraAnswers = { ...baseExtraAnswers, ...extraAnswers }
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setAttendance(state, attendance) {
    state.attendance = attendance
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setPatientAcceptedTerms(state, value) {
    if (state.attendance?.patient) {
      state.attendance.patient.acceptedTerms = value
    }
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setTreatments(state, treatments) {
    state.treatments = treatments
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setIsSaving(state, isSaving) {
    state.isSaving = isSaving
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  toggleIsSaving(state) {
    state.isSaving = !state.isSaving
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setIsSynced(state, isSynced) {
    state.isSynced = isSynced
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  setVersion(state, version) {
    state.version = version
  },

  /** @type {Mutation<NewAttendanceFormState>} */
  clear(state) {
    Object.assign(state, getInitialState())
  },
}
